document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-card-animation]').forEach((section) => {
      const multicolumnList = section.querySelector('.multicolumn-list');
      if (!multicolumnList) return;

      function updateCardHeight() {
        const panels = multicolumnList.querySelectorAll('.panel .multicolumn-card');
        if (!panels.length) return;

        let maxHeight = 0;
        panels.forEach((panel) => {
          panel.style.removeProperty('height');
          const h = panel.getBoundingClientRect().height;
          if (h > maxHeight) maxHeight = h;
        });

        multicolumnList.style.setProperty('--cardHeight', `${Math.ceil(maxHeight)}px`);
      }

      window.addEventListener('load', updateCardHeight);

      window.addEventListener('resize', () => {
        requestAnimationFrame(updateCardHeight);
      });

      const panelObserver = new ResizeObserver(updateCardHeight);
      multicolumnList.querySelectorAll('.panel').forEach((panel) => {
        panelObserver.observe(panel);
      });
      updateCardHeight();
    });
});